<template>
  <div>
    <!--기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :options="[
        { type: 'date', label: '점검일' },
        { type: 'text', label: '점검장소' },
        { type: 'disaster', label: '재해형태' },
      ]"
      :board="this.board"
      :is-print="isPrint"
    />

    <!--    점검구분-->
    <vs-row class="mt-6">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot" /> 점검구분</h5>
      </vs-col>
    </vs-row>
    <div class="mt-4 flex" v-if="!isPrint">
      <vs-radio :disabled="board.readonly" v-model="form.checkType" vs-value="정기" class="mr-4">정기</vs-radio>
      <vs-radio :disabled="board.readonly" v-model="form.checkType" vs-value="임시" class="mr-4">임시</vs-radio>
    </div>
    <div class="mt-4" v-else>
      <span class="print-radio"><i><feather-icon v-if="form.checkType === '정기' " svgClasses="w-4 w-5" icon="CheckIcon" /></i>정기</span>
      <span class="print-radio"><i><feather-icon v-if="form.checkType === '임시' " svgClasses="w-4 w-5" icon="CheckIcon" /></i>임시</span>
    </div>

    <!--    점검대상-->
    <vs-row class="mt-6">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot" /> 점검대상</h5>
      </vs-col>
    </vs-row>

    <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-3 flex items-center"
           v-for="checkbox in form.inspectList"
           v-bind:key="checkbox.id"
      >
        <div v-if="isPrint || board.readonly" class="flex">
          <div v-if="checkbox.check" style="background: #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2" >
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          <div v-else style="border: 1px solid #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2" >
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          {{ checkbox.label }}
        </div>
        <label v-else class="flex">
          <vs-checkbox
            :readonly="board.readonly"
            v-model="checkbox.check"
            @change="checkForm">
          </vs-checkbox>
          {{ checkbox.label }}
        </label>
      </div>
    </div>

    <!--    표-->
    <div
      v-for="(inspection, indexRows) in form.inspectList"
      v-bind:key="inspection.id"
    >
      <table-inspect
        class="mt-5"
        v-bind:key="inspection.id"
        :is-print="isPrint"
        :is-readonly="board.readonly"
        :is-show-title="true"
        :isNote="true"
        :title="inspection.title"
        :list="inspection.list"
        table-header-title="점검항목"
        table-header-note="개선요망 사항"
        @update-list-check="(param1, param2)=>{
        updateListCheck(indexRows,param1,param2
        )}"
        v-if="inspection.check"
      />
    </div>

    <vs-row class="mt-4">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 기타 점검사항</h5>
      </vs-col>
    </vs-row>
    <div class="grid grid-cols-12 gap-x-6 mt-4">
      <div class="print-container col-span-12 flex items-start">
        <p v-if="isPrint" class="print-textarea">{{ form.inputC_1 }}</p>
        <vs-textarea
          :readonly="board.readonly"
          v-else
          v-model="form.inputC_1"
          class="flex-1 w-full"
          rows="5"
        />
      </div>
    </div>

    <!--    사진대지-->
    <PhotoUploadGridModule
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :isPrint="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검"
    />

    <!-- 파일첨부 -->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from '@/views/modules/FieldSelectModule'
import PopupPlanProject from '@/views/project/popup/PopupPlanProject'
import DateSelector from '@/components/selector/DateSelector'
import PopupProjectSetting from '@/views/project/PopupProjectSetting'
import MemberSelector from '@/components/selector/MemberSelector'
import CompanySelector from '@/components/selector/CompanySelector'
import FileUploader from '@/components/FileUploader'
import FileUploadModule from '@/views/modules/FileUploadModule'
import TableInspect from '@/components/TableInspect'
import TableDuration from '../../../../components/TableDuration'
import PhotoUploadGridModule from '@/views/modules/PhotoUploadGridModule'

export default {
  components: {
    PhotoUploadGridModule,
    TableDuration,
    TableInspect,
    FieldSelectModule,
    FileUploadModule,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler (value) {
        const keys = Object.keys(this.form)
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key]
          }
        }

        if (!this.form || !this.form.inspectList || this.form.inspectList.length === 0) {
          this.form.inspectList = this.inspectTable
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler (value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    checkForm () {
      this.form.typeTitleList = []
      for (const data of this.form.inspectList) {
        if (data.check) {
          this.form.typeTitleList.push(data.label)
        }
      }
    },
    updateListCheck (indexList, indexTableRows, text) {
      this.form.inspectList[indexList].list[indexTableRows].is_checked = text
    },
  },
  data () {
    return {
      form: {
        stdInfo: {},
        checkType: '정기',
        inputC_1: '',

        typeTitleList: [],
        inspectList: [],
        photoList: [],
        fileList: [],
      },
    }
  },
  computed: {
    inspectTable () {
      return [
        {
          id: 1,
          label: '추락',
          check: false,
          title: '추락',
          list: [
            {
              id: 1,
              label: "개구부의 방호조치(E/V, 바닥개구부, 안전난간, 덮개 등 )",
              is_checked: "",
              note: ''
            },
            {
              id: 2,
              label: "안전망 설치 및 부착, 설치방법 준수상태",
              is_checked: "",
              note: ''
            },
            {
              id: 3,
              label: "틀비계 설치상태(상부 안전난간, 승강설비등 설치기준)",
              is_checked: "",
              note: ''
            },
            {
              id: 4,
              label: "작업발판 단부 추락방지조치(안전난간, 안전망)",
              is_checked: "",
              note: ''
            },
            {
              id: 5,
              label: "말비계 안전난간대 설치 및 추락방지 시설 설치 상태",
              is_checked: "",
              note: ''
            },
            {
              id: 6,
              label: "고소작업장 추락방지시설물 유무 및 올바른 설치상태",
              is_checked: "",
              note: ''
            },
            {
              id: 7,
              label: "가설통로 및 경사로 설치기준(미끄럼방지, 폭 등)준수여부",
              is_checked: "",
              note: ''
            },
            {
              id: 8,
              label: "사다리 사용금지 여부",
              is_checked: "",
              note: ''
            },
          ],
        },
        {
          id: 2,
          label: '붕괴, 도괴',
          check: false,
          title: '붕괴, 도괴',
          list: [
            {
              id: 1,
              label: "굴착면의 안정성(가시설, 안전표지설치 등)",
              is_checked: "",
              note: ''
            },
            {
              id: 2,
              label: "굴착단부 및 인접부 중량물 적재여부",
              is_checked: "",
              note: ''
            },
            {
              id: 3,
              label: "작업발판의 설치상태(고정상태, 폭, 재질)",
              is_checked: "",
              note: ''
            },
            {
              id: 4,
              label: "거푸집동바리 설치상태(규격품, 구조계산, 조립도 작성여부)",
              is_checked: "",
              note: ''
            },
            {
              id: 5,
              label: "비계조립상태 및 벽연결 상태",
              is_checked: "",
              note: ''
            },
            {
              id: 6,
              label: "경사법면 보호망(덮개) 설치 여부",
              is_checked: "",
              note: ''
            },
          ],
        },
        {
          id: 3,
          label: '낙하, 비래',
          check: false,
          title: '낙하, 비래',
          list: [
            {
              id: 1,
              label: "낙하물방지망 설치상태 및 조립기준 준수여부",
              is_checked: "",
              note: ''
            },
            {
              id: 2,
              label: "리프트, 주출입구 방호선반 설치상태",
              is_checked: "",
              note: ''
            },
            {
              id: 3,
              label: "비계상의 자재 적재 상태",
              is_checked: "",
              note: ''
            },
            {
              id: 4,
              label: "안전난간대 수직보호망 및 폭목 설치상태",
              is_checked: "",
              note: ''
            },
            {
              id: 5,
              label: "단부구간 자재 적재상태",
              is_checked: "",
              note: ''
            },
            {
              id: 6,
              label: "높은 위치에 놓아둔 자재의 정리정돈 상태",
              is_checked: "",
              note: ''
            },
          ],
        },
        {
          id: 4,
          label: '전기기계',
          check: false,
          title: '전기기계',
          list: [
            {
              id: 1,
              label: "임시수전반 설치상태(울타리, 출입통제, 표지판 등)",
              is_checked: "",
              note: ''
            },
            {
              id: 2,
              label: "임시분전함 설치상태(외함접지, 시건조치, 누전차단기 등)",
              is_checked: "",
              note: ''
            },
            {
              id: 3,
              label: "임시전선 및 이동전선 설치상태",
              is_checked: "",
              note: ''
            },
            {
              id: 4,
              label: "이동식 전기기계기구 사용상태(누전차단기, 접지 등)",
              is_checked: "",
              note: ''
            },
            {
              id: 5,
              label: "교류아크용접기 사용상태(전격방지기, 접지, 충전부)",
              is_checked: "",
              note: ''
            },
          ],
        },
        {
          id: 5,
          label: '건설기계 기구,양중장비',
          check: false,
          title: '건설기계 기구,양중장비',
          list: [
            {
              id: 1,
              label: "호이스트, 타워크레인 안전조치상태",
              is_checked: "",
              note: ''
            },
            {
              id: 2,
              label: "둥근톱 방호장치, 역화방지기, 자동전격방지기 사용상태",
              is_checked: "",
              note: ''
            },
            {
              id: 3,
              label: "중장비 관련서류 구비상태(면허증, 보험증, 등록증 등)",
              is_checked: "",
              note: ''
            },
            {
              id: 4,
              label: "중장비 작업전 안전교육 실시여부 및 유자격자 운전여부",
              is_checked: "",
              note: ''
            },
            {
              id: 5,
              label: "크레인등 작업시 아웃트리거 설치, 깔판.받침목 사용 여부",
              is_checked: "",
              note: ''
            },
            {
              id: 6,
              label: "양중박스 관리 상태",
              is_checked: "",
              note: ''
            },
            {
              id: 7,
              label: "줄걸이 도구 점검상태",
              is_checked: "",
              note: ''
            },
            {
              id: 8,
              label: "유도 또는 신호수 배치상태",
              is_checked: "",
              note: ''
            },
            {
              id: 9,
              label: "차량계 건설기계 작업계획서 작성여부",
              is_checked: "",
              note: ''
            },
            {
              id: 10,
              label: "중량물 취급 작업계획서 작성여부",
              is_checked: "",
              note: ''
            },
          ],
        },
        {
          id: 6,
          label: '화재예방 및 기타 위험시설의 방호조치',
          check: false,
          title: '화재예방 및 기타 위험시설의 방호조치',
          list: [
            {
              id: 1,
              label: "용접작업주변에 인∙발화성, 가연성물질 방치여부 및 소화기 비치여부",
              is_checked: "",
              note: ''
            },
            {
              id: 2,
              label: "작업장, 창고 등에서 통제없이 불을 피우는 일은 없는가",
              is_checked: "",
              note: ''
            },
            {
              id: 3,
              label: "유해, 위험물질의 보관상태(위험물저장시설 및 경고표지)",
              is_checked: "",
              note: ''
            },
            {
              id: 4,
              label: "산소결핍장소(밀폐공간) 작업전∙중 안전조치 여부",
              is_checked: "",
              note: ''
            },
            {
              id: 5,
              label: "지하매설물 방호조치 여부",
              is_checked: "",
              note: ''
            },
            {
              id: 6,
              label: "현장내 교통안전시설물 설치 상태",
              is_checked: "",
              note: ''
            },
            {
              id: 7,
              label: "현장내 교통사고예방 안전조치여부",
              is_checked: "",
              note: ''
            },
          ],
        },
      ];
    }
  },
}
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
$w-inpu0: 260px;
$w-inpu1: 220px;
$w-inpu2: 140px;
.center-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.bg-1 {
  background-color: #f9f9f9;
  border-bottom: $border;
}

.label-text {
  width: 110px;
  font-weight: 500;
  font-size: 14px;
  padding-right: 12px;
}

.mt-component-form {
  margin-top: 15px;
}

.text-box {
  line-height: 19px;
  margin-top: 15px;
  border: $border;
}

/* uploaded File */
.form-group {
  border: $border;
  overflow: auto;
  width: 100%;
  /*overflow-x: auto;*/

  &__header {
    height: 80px;
    width: 100%;
    display: flex;

    &-title {
      min-width: $w-inpu2;
      border-left: $border;
      border-bottom: $border;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &-title.title-checked {
      margin: 0;
      min-width: 40px;
      max-width: 40px;
      border-left: none;
      padding-left: 10px;
    }
  }

  &__content {
    width: 100%;
    display: flex;

    &-row {
      min-width: $w-inpu2;
      border-left: $border;
      border-bottom: $border;
      padding: 7px;
    }

    &-row.row-checked {
      margin: 0;
      min-width: 40px;
      max-width: 40px;
      border-left: none;
      padding-left: 10px;
    }

    &-row.row-w2 {
      min-width: $w-inpu1;
    }
  }
}

.row-w1 {
  min-width: $w-inpu1;
}

.row-w0 {
  min-width: $w-inpu0;
}

.bx {
  border-left: $border;
  border-right: $border;
}

.br {
  border-right: $border;
}

.bb {
  border-bottom: $border;
}

.print-radio,
.print-checkbox {
  display: flex;
  align-items: center;
  margin-right: 1rem;

  & > i { width:20px; height: 20px; border:2px solid #cdcdcd; position: relative; margin-right: 6px; }
  & .feather-icon { transform: translateY(-4px); }
}

.print-radio {
  & > i { border-radius: 20px; }
}
</style>
